const UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

export function bytes(value: number | null | undefined): string {
  if (value == null) {
    return '—';
  }

  if (value < 1024) {
    return `${value} B`;
  }

  let size = value;
  let unit = 0;

  while (size >= 1024 && unit < UNITS.length - 1) {
    size /= 1024;
    unit += 1;
  }

  return `${size.toFixed(size >= 100 ? 0 : 1)} ${UNITS[unit]}`;
}

export function count(value: number | null | undefined): string {
  return value == null ? '—' : value.toLocaleString('en-US');
}

export function percent(fraction: number | null | undefined): string {
  return fraction == null ? '—' : `${(fraction * 100).toFixed(1)}%`;
}

export function timestamp(value: string | null | undefined): string {
  if (!value) {
    return '—';
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? value : parsed.toLocaleString();
}

export function text(value: string | null | undefined): string {
  return value && value.length > 0 ? value : '—';
}
